import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useCustomPageTitle } from '../../hooks/usePageTitle';
import EstimatesList from '../../components/dashboard/EstimatesList';
import DashboardHeader from '../../components/dashboard/DashboardHeader';

const Dashboard = () => {
  const { user } = useAuth();
  useCustomPageTitle('Tableau de bord - Mes estimations');

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <DashboardHeader />
      <div className="mt-8">
        <EstimatesList userId={user?.uid} />
      </div>
    </div>
  );
};

export default Dashboard;